import { render, staticRenderFns } from "./InfoHeaderCard.vue?vue&type=template&id=e26115ba"
import script from "./InfoHeaderCard.vue?vue&type=script&lang=js"
export * from "./InfoHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports